import { combineReducers } from 'redux';

import CurrencyTypes from './types';

export const currencyReducer = combineReducers({
  list: CurrencyTypes.list.getReducer(),
});
